/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Choose_T2Inputs */

const en_site_choose_t2 = /** @type {(inputs: Site_Choose_T2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dissect & interview`)
};

const id_site_choose_t2 = /** @type {(inputs: Site_Choose_T2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedah & wawancara`)
};

/**
* | output |
* | --- |
* | "Dissect & interview" |
*
* @param {Site_Choose_T2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_choose_t2 = /** @type {((inputs?: Site_Choose_T2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Choose_T2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_choose_t2(inputs)
	return en_site_choose_t2(inputs)
});